import React from 'react';
import styles from './BackgroundDecorations.module.scss';

const BackgroundDecorations: React.FC = () => {
  return (
    <div className={styles.decorations}>
      <div className={styles.circleLeft} />
      <div className={styles.circleRight} />
      <div className={styles.arc} />
    </div>
  );
};

export default BackgroundDecorations;
